import React from "react";
import { useTranslation } from "react-i18next";
import DashboardSidebarMenu from "../../../components/controls/DashboardSideBarMenu";
import { getManagementMenus } from "../../../contexts/ManagementMenus";
import { useAuth } from "../../../contexts/AuthContext";

export default function ManagementDashboard() {
  const { t } = useTranslation();
  const { hasPermission } = useAuth();

  const title = t("management.title", "Gestion");
  const menus = getManagementMenus(hasPermission);

  return (
    <div className="flex">
      <DashboardSidebarMenu title={title} menus={menus} />

      <div className="flex-1 p-6 text-onWhite">
        <h1 className="text-2xl font-bold">
          {t("management.dashboardDescription", "Section de gestion")}
        </h1>

        <p className="mt-3 text-gray-500">
          {t(
            "management.dashboardHint",
            "Sélectionnez un module dans le menu à gauche."
          )}
        </p>
      </div>
    </div>
  );
}
